// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Luna Point 2
 * Service Luna Point 2
 * Version: v.0.0.0
 */
/**
 * Role visibility level controlling record access scope. "global" - access to all records in the system. "local" - access to records within user's departments. "basic" - access only to open records within user's departments.
 */
export type PermissionsVisibility = typeof PermissionsVisibility[keyof typeof PermissionsVisibility];


export const PermissionsVisibility = {
  global: 'global',
  local: 'local',
  basic: 'basic',
} as const;
